import { useCallback } from 'react'
import { useApi } from '@/lib/api'

export interface WorkerStartDateConflict {
  userProfileId: number
  hasSubmittedHoursConflict: boolean
  hasTransactionConflict: boolean
  hasConflict: boolean
}

/**
 * Pre-flight check for pushing a worker's First Day of Work later. Asks the EngagementService whether the
 * worker has submitted timesheet hours or live financial transactions dated BEFORE a proposed start, so the
 * UI can block an invalid push before it is saved. Mirror of useWorkerEndDateConflict (the end-date reduction
 * pre-flight). The same guards run again during the legacy sync as a backstop, but blocking here keeps the
 * bad date out of the engagement doc.
 */
export function useWorkerStartDateConflict() {
  const { engagementApi } = useApi()

  const checkStartDateConflict = useCallback(
    // recordId scopes the check to this engagement's assignment — matching the engagement-scoped guard;
    // without it the check would over-block on a worker's hours/transactions from other engagements.
    async (recordId: number, workerUserProfileId: number, proposedStartDate: string): Promise<WorkerStartDateConflict> => {
      const path = `/api/Engagement/${recordId}/worker/${workerUserProfileId}/start-date-conflicts?proposedStartDate=${proposedStartDate}`
      return await engagementApi.get<WorkerStartDateConflict>(path)
    },
    [engagementApi]
  )

  return { checkStartDateConflict }
}
